import '../../../node_modules/react-grid-layout/css/styles.css';
import '../../../node_modules/react-resizable/css/styles.css';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, getFormValues } from 'redux-form';
import _ from 'lodash';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloseIcon from '@mui/icons-material/Close';

import CardComponent from '../components/Card';
import ColSettings from '../components/ColSettings';
import { CardElement, AddButton, EmptyState } from '../../_Components';
import { Options } from '../../_utils/_constants';

const typeName = (id) => {
    const item = Options.FieldsTypesOptions.find((option) => option.id === id);
    return item ? item.name : (id || '');
};

class CardEdit extends React.PureComponent {
    static defaultProps = {
        className: "layout",
        cols: 12,
        autoSize: false,
        rowHeight: 48,
        maxRows: 4
    };

    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.openAdd = null;
        this.state = {
            selectedIndex: 0,
            selected: null,
            oldlayout: null,
            width: 0,
            preview: false
        };

        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.selectCol = this.selectCol.bind(this);
        this.updateItems = this.updateItems.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.registerAdd = this.registerAdd.bind(this);
    }

    registerAdd(fn) {
        this.openAdd = fn;
    }

    selectCol(index) {
        const { formValues: { cols } } = this.props;
        const i = _.findIndex(cols, {field: index});
        this.setState({selectedIndex: i, preview: false});
    }
    onDragStart(layout,element){
        this.selectCol(element.i);
    }
    addItem(item) {
        const { formValues: { cols }, change } = this.props;
        const next = [...(cols || []), {
            ...item,
            col : item.x,
            row : item.y,
            sizeX : item.w,
            sizeY: item.h,
        }];
        change('cols', next);
        this.setState({ selectedIndex: next.length-1 });
    }

    updateItems(items) {
        const { formValues, change } = this.props;
        if(formValues.cols.length===items.length){
            const newItems = items.map( (item) => {
                const el = formValues.cols.find( el => el.field=== item.i);
                return {
                    ...el,
                    col : item.x,
                    row : item.y,
                    sizeX : item.w,
                    sizeY: item.h,
                };
            });
            change('cols', newItems);
        }
    }

    removeItem(i) {
        const { formValues: { cols }, change } = this.props;
        const next = (cols || []).filter((_, index) => index !== i);
        change('cols', next);
        this.setState({ selectedIndex: next.length ? 0 : -1 });
    }

    removeSelected = () => {
        const { selectedIndex } = this.state;
        if (selectedIndex < 0) return;
        this.removeItem(selectedIndex);
    }

    updateLayoutElements=()=>{
        if (!this.ref.current) return;
        const next = Math.floor(this.ref.current.clientWidth);
        if (next > 0 && this.state.width !== next) {
            this.setState({ width: next });
        }
    }
    componentDidMount(){
        window.addEventListener('resize', this.updateLayoutElements);
        this.updateLayoutElements();
        if (typeof ResizeObserver !== 'undefined' && this.ref.current) {
            this.resizeObserver = new ResizeObserver(() => this.updateLayoutElements());
            this.resizeObserver.observe(this.ref.current);
        }
    }
    componentDidUpdate(){
        this.updateLayoutElements();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateLayoutElements);
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    renderPreview(cols, fields) {
        const rows = {};
        (cols || []).forEach((col) => {
            const row = col.row || 0;
            if (!rows[row]) rows[row] = [];
            rows[row].push(col);
        });
        const keys = Object.keys(rows).map(Number).sort((a, b) => a - b);
        return (
            <div className="pc-pv">
                {keys.map((row) => (
                    <div className="pc-pv__row" key={row}>
                        {rows[row]
                            .sort((a, b) => (a.col || 0) - (b.col || 0))
                            .map((col) => {
                                const meta = (fields || []).find((item) => item.id === col.field);
                                return (
                                    <div
                                        className="pc-pv__f"
                                        key={col.field}
                                        style={{
                                            gridColumn: `${(col.col || 0) + 1} / span ${Math.max(1, col.sizeX || 2)}`,
                                        }}
                                    >
                                        <div className="pc-pv__l">
                                            {meta ? meta.name : col.field}
                                            {col.required ? <i>*</i> : null}
                                        </div>
                                        <div className={`pc-pv__box${col.readonly ? ' is-ro' : ''}`}>
                                            {typeName(meta && meta.type) || 'Введите значение'}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const { fields, formValues } =  this.props;
        const  { selectedIndex, preview } = this.state;
        if (!formValues) {
            return null;
        }
        const cols = formValues.cols || [];
        const selected = selectedIndex >= 0 ? cols[selectedIndex] : null;

        return (
            <div className="pc-fill">
                <div className="pc-split pc-split--form">
                    <CardElement
                        fill
                        title="Форма оператора"
                        subheader="то, что заполняется во время звонка"
                        action={(
                            <Fragment>
                                <Button
                                    size="small"
                                    variant={preview ? 'contained' : 'outlined'}
                                    startIcon={<VisibilityOutlinedIcon sx={{ fontSize: '14px !important' }} />}
                                    onClick={() => this.setState({ preview: !preview })}
                                >
                                    Предпросмотр
                                </Button>
                                <AddButton
                                    label="Добавить поле"
                                    handleAddClick={() => this.openAdd && this.openAdd()}
                                    variant="contained"
                                />
                            </Fragment>
                        )}
                        content={(
                            <div className="pc-panel-body">
                                <div className="pc-canvas">
                                    <div className="pc-sheet">
                                        <div className="pc-sheet__sh">
                                            {preview ? 'Так карточку видит оператор' : `Карточка «${formValues.name || ''}» · ${cols.length} полей`}
                                        </div>
                                        {preview ? this.renderPreview(cols, fields) : (
                                            <div ref={this.ref} className="pc-formgrid-wrap">
                                                <CardComponent
                                                    width={this.state.width || 480}
                                                    elements={cols}
                                                    fields={fields || []}
                                                    selectedIndex={selectedIndex}
                                                    addItem={this.addItem}
                                                    selectCol={this.selectCol}
                                                    removeEvent={this.removeItem}
                                                    updateItems={this.updateItems}
                                                    onDragStart={this.onDragStart}
                                                    registerAdd={this.registerAdd}
                                                    hideAdd
                                                    rowHeight={48}
                                                    margin={[8, 8]}
                                                    containerPadding={[0, 0]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    />
                    <CardElement
                        fill
                        title="Свойства поля"
                        action={selected ? (
                            <IconButton size="small" title="Убрать из формы" onClick={this.removeSelected}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        ) : null}
                        content={(
                            <div className="pc-panel-body">
                                <div className="pc-tblwrap">
                                    {selected ? (
                                        <ColSettings
                                            path="cols"
                                            items={cols}
                                            item={selected}
                                            selectedIndex={selectedIndex}
                                            fields={fields || []}
                                        />
                                    ) : (
                                        <EmptyState
                                            title="Поле не выбрано"
                                            description="Кликните поле в форме, чтобы настроить его."
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const formValues = getFormValues('card')(state);
    const { fetch } = state;
    return {
        formValues,
        isLoading: !!fetch.loading
    }
};

export default  compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    }),
)(CardEdit);
